module.exports = __webpack_public_path__ + "img/stylus.be8e39cd.svg";